import { Button as AriaButton } from 'react-aria-components'
import { useMe } from 'src/services/helpers/user'
import { useShowEmailVerificationDot } from 'src/utils/user'
import { tv, type VariantProps } from 'tailwind-variants'
import IcRoundTranslate from '~icons/ic/round-translate'
import UserAvatar from '../UserAvatar'
import AccountMenu from './AccountMenu'
import SignButton from './SignButton'

const buttonStyles = tv({
  slots: {
    button: 'cursor-pointer',
    icon: '',
  },
  variants: {
    size: {
      normal: {
        button: 'size-8',
        icon: 'size-5',
      },
      large: {
        button: 'size-10',
        icon: 'size-6',
      },
    },
  },
  defaultVariants: {
    size: 'normal',
  },
})

export default function AccountButton(
  props: StyleProps & VariantProps<typeof buttonStyles>,
) {
  const { me } = useMe()
  const [showDot, updateDotState] = useShowEmailVerificationDot(
    'account-btn',
    me,
  )

  const styles = buttonStyles({
    size: props.size,
  })

  return (
    <>
      {!me && <SignButton size={props.size} />}

      <AccountMenu>
        <AriaButton
          className={styles.button({
            className: [
              'shrink-0 rounded-full',
              !me &&
                'grid place-content-center bg-background-secondary border border-black/50 dark:border-white/50 rounded-full',
              props.className,
            ],
          })}
          style={props.style}
          onPress={() => {
            updateDotState()
          }}
        >
          {me ? (
            <UserAvatar
              user={me}
              displayRedDot={showDot}
              className="size-full"
            />
          ) : (
            <IcRoundTranslate className={styles.icon()} />
          )}
        </AriaButton>
      </AccountMenu>
    </>
  )
}
